import { Box } from '@mui/material';

interface IProps {
  children: React.ReactNode;
}

function EventCompletionContent({ children }: IProps) {
  return <Box sx={{ mb: 4 }}>{children}</Box>;
}

export default EventCompletionContent;
